import { forwardRef, type Ref, type SVGProps } from "react";
const IconDeleteOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M27 6h-5.38l-1.45-2.9A1.99 1.99 0 0 0 18.38 2h-4.76a1.99 1.99 0 0 0-1.8 1.1L10.39 6H5a1 1 0 0 0 0 2h1v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8h1a1 1 0 0 0 0-2M13.62 4h4.76l1 2h-6.76zM24 28H8V8h16z" />
    <path d="M13 26a1 1 0 0 0 1-1V11a1 1 0 0 0-2 0v14a1 1 0 0 0 1 1m6 0a1 1 0 0 0 1-1V11a1 1 0 0 0-2 0v14a1 1 0 0 0 1 1" />
  </svg>
);
const ForwardRef = forwardRef(IconDeleteOutlineSVG);
ForwardRef.displayName = "IconDeleteOutline";
export { ForwardRef as IconDeleteOutline };
